import SliderWrapper from 'components/3cat/SliderWrapper';

export default function KeyframeSenseAvantitolWrapper(props) {
    return <SliderWrapper {...props} hideAvantitol={true} />;
}
